export default "__VITE_ASSET__CDs6mUnn__"